/* ----------------------------------------------------------------------------------------------------
 * ML REASSURANCE: <ml-reassurance> custom element (EE build 2026-09-24)
 *
 * Turns the static "Free delivery over R1,500" line into a nudge based on what is already in the cart:
 *   cart below threshold  → "You're R300 away from free delivery" + progress bar
 *   cart at/over threshold → "Your order ships with free delivery"
 *   cart empty / fetch fails → the static line stays as rendered by Liquid
 *
 * Reads /cart.js once on connect, then follows Impact's `cart:change` (bubbles to document, detail.cart).
 * The element is re-created on every variant change (it lives inside <buy-buttons>), so it keeps the last
 * known total on the class to avoid refetching.
 *
 * 2026-10-03: the static free-delivery offer now lives in the trust row, so the nudge line ([data-free-nudge]) stays
 * hidden on an empty cart and is unhidden by render().
 *
 * Paired with snippets/ml-reassurance.liquid. Copy lives in locales/en.default.json → ml_reassurance.*
 * -------------------------------------------------------------------------------------------------- */

if (!customElements.get('ml-reassurance')) {
  const format = (cents) => 'R' + Math.ceil(cents / 100).toLocaleString('en-US');

  class MlReassurance extends HTMLElement {
    static total = null;

    connectedCallback() {
      this.line = this.querySelector('[data-free-delivery]');
      this.bar = this.querySelector('[data-free-bar]');
      this.nudge = this.querySelector('[data-free-nudge]');
      if (!this.line) return;
      this.threshold = parseInt(this.getAttribute('threshold'), 10) || 0;
      this.onChange = (event) => {
        const cart = event.detail && event.detail.cart;
        if (cart) this.render((MlReassurance.total = cart.total_price));
      };
      document.addEventListener('cart:change', this.onChange);

      if (MlReassurance.total !== null) return this.render(MlReassurance.total);
      fetch(`${window.Shopify?.routes?.root || '/'}cart.js`)
        .then((r) => r.json())
        .then((cart) => this.render((MlReassurance.total = cart.total_price)))
        .catch(() => {});
    }

    disconnectedCallback() {
      document.removeEventListener('cart:change', this.onChange);
    }

    render(total) {
      if (!this.threshold || !total) return; // empty cart: the trust row already states the offer
      const reached = total >= this.threshold;
      if (this.nudge) this.nudge.hidden = false;
      // Messages are theme locale strings (…_html keys), not user input.
      this.line.innerHTML = reached ? this.dataset.reached : this.dataset.away.replace('__AMOUNT__', format(this.threshold - total));
      if (this.bar) {
        this.bar.hidden = reached;
        this.bar.style.setProperty('--progress', Math.min(total / this.threshold, 1).toFixed(3));
      }
    }
  }

  customElements.define('ml-reassurance', MlReassurance);
}
